import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public isNavHeaderFullWidth = new BehaviorSubject<boolean>(true);
  isNavHeaderFullWidth$ = this.isNavHeaderFullWidth.asObservable();


  constructor() { }


  /**
   * Function is used to check file type.
   * @param url 
   * @returns 
   */
  getFileType(url: any) {
    let extension = url?.split('.').pop().split('?')[0];
    let mimeTypes: any = {
      'pdf': 'application/pdf',
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'txt': 'text/plain',
      'html': 'text/html',
    };
    return mimeTypes[extension?.toLowerCase()] || 'unknown';
  }
}
